export enum OTP_TYPE {
	SMS = 'sms',
	EMAIL = 'email',
}
